<div class="scrollable" *ngIf="rows.length">
  <table class="table table-striped">
    <thead>
    <tr>
      <ng-container *ngFor="let header of headers">
        <ng-container *cmLet="(getHeaderName | thunk : header) as headerName;">
          <th
            (click)="onHeaderClick(header)"
            [ngClass]="{'table-col--clickable': header.sortable}"
            class="table-col"
            [ngStyle]="getHeaderStyle(header)">
            <div class="th-container">
              <div *ngIf="headerName.length < 30">
                {{headerName}}
              </div>
              <div *ngIf="!(headerName.length < 30)" [ngbTooltip]="headerName" container="body" class="text-ellipsis">
                {{headerName}}
              </div>
              <div *ngIf="header.type === ColumnTypeId.CHECK && allowSelectAllCheckboxes">
                <input
                  id="select-all-rows"
                  type="checkbox"
                  name="select-all-rows"
                  class="cm-checkbox"
                  [(ngModel)]="allRowsChecked"
                  (ngModelChange)="selectAllRows(header)"/>
                <label for="select-all-rows" class="cm-checkbox-label"></label>
              </div>
              <i *ngIf="header.helpTooltip"
                 class="fa fa-question-circle"
                 [container]="header.helpTooltip?.container || 'body'"
                 [tooltipClass]="header.helpTooltip?.class"
                 [ngbTooltip]="header.helpTooltip?.text || ('' + header.helpTooltip)"
              ></i>
              <i class="fa" [ngClass]="getHeaderCssClass | thunk : header : order"></i>
            </div>
          </th>
        </ng-container>
      </ng-container>
    </tr>
    </thead>
    <tbody *ngIf="rows.length">

    <ng-container *ngFor="let row of rows; trackBy: trackByFn">
      <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: row, 'childrenTpl': childrenTpl }">
      </ng-container>
      <ng-template #childrenTpl>
        <ng-container *ngIf="row[childrenParam] && row._showChildren">
          <ng-container *ngFor="let childRow of row[childrenParam]; trackBy: trackByFn">
            <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: childRow }">
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-template>
    </ng-container>
    </tbody>
  </table>
</div>

<div *ngIf="!rows.length" class="no-result">
  <h3 class="title">No results</h3>
  <p class="description">{{config.noEntries}}</p>
</div>

<ng-template #rowTemplate let-row let-childrenTpl="childrenTpl">
  <tr (click)="onRowClicked(row)"
      [ngClass]="{'table-row-clickable': config.rowClickable, 'has-errors': config.rowHasError | thunk: row}"
      [ngStyle]="getRowStyle(row)">
    <td *ngFor="let header of headers"
        (click)="SERVICE_COLUMNS.includes(header.propertyName) ? serviceColumnClick($event, header, row): null">
      <cm-smart-table-popover
        [ngbTooltip]="header.tooltip && header.tooltip(row)"
        placement="top-left"
        container="body"
        [template]="header.popover?.template"
        [content]="{row: row, header: header}"
        (skipNextRowClick)="onSkipNextRowClick()">
        <cm-dynamic-cell
          [component]="getCellComponent | thunk : header.type"
          [data]="{row: row, header: header}"
          (action)="onDynamicCellAction(header, row, $event)">
        </cm-dynamic-cell>
      </cm-smart-table-popover>
    </td>
  </tr>
  <tr [style.height]="rowDetailsRef ? 'auto' : 0" [ngStyle]="getRowStyle(row)">
    <td [colSpan]="headers.length" class="row-details">
      <ng-container *ngTemplateOutlet="rowDetailsRef; context: { row: row }"></ng-container>
    </td>
  </tr>
  <ng-container *ngTemplateOutlet="childrenTpl"></ng-container>
</ng-template>
<ng-template let-row="row" let-header="header" #expandableRow>
  <ng-container class="" *ngIf="row[childrenParam]?.length">
    <span class="fa chevron-grey"
          [ngClass]="row._showChildren ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
  </ng-container>
</ng-template>
